import HttpService from "./http-service";
import Provinces from "@/entities/territorial-division/provinces";
import Districts from "@/entities/territorial-division/districts";
import Townships from "@/entities/territorial-division/townships";
import AsyncPaginatedRequest from "./async-paginated-request";
import { LazyAsyncIter } from "@/iterators";
import { Paginated } from "@/pagination";
//import { AxiosResponse } from 'axios'

export default class NewsService extends HttpService {
  public searchProvincesAsync(): LazyAsyncIter<Paginated<Provinces>> {
    const reqIter = new AsyncPaginatedRequest<ProvincesDTO>(
      "get",
      "territorial-division/provinces",
      undefined,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();

    return new LazyAsyncIter(reqIter).map((page) => ({
      ...page,
      pageElements: page.pageElements?.map(ProvincesFromDTO),
    }));
  }

  public searchDistrictsAsync(
    province_id: number
  ): LazyAsyncIter<Paginated<Districts>> {
    const reqIter = new AsyncPaginatedRequest<DistrictsDTO>(
      "get",
      `territorial-division/provinces/${province_id}/districts`,
      undefined,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();

    return new LazyAsyncIter(reqIter).map((page) => ({
      ...page,
      pageElements: page.pageElements?.map(DistrictsFromDTO),
    }));
  }

  public searchTownshipsAsync(
    district_id: number
  ): LazyAsyncIter<Paginated<Townships>> {
    const reqIter = new AsyncPaginatedRequest<TownshipsDTO>(
      "get",
      `territorial-division/districts/${district_id}/townships`,
      undefined,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();

    return new LazyAsyncIter(reqIter).map((page) => ({
      ...page,
      pageElements: page.pageElements?.map(TownshipsFromDTO),
    }));
  }
}

/**
 * Provinces
 */
export interface ProvincesDTO {
  id: number;
  name: string;
  cod_province: string;
}

export function ProvincesFromDTO(dto: ProvincesDTO): Provinces {
  return new Provinces({
    id: dto.id,
    name: dto.name,
    cod_province: dto.cod_province,
  });
}

/**
 * Districts
 */
export interface DistrictsDTO {
  id: number;
  name: string;
  cod_district: string;
}

export function DistrictsFromDTO(dto: DistrictsDTO): Districts {
  return new Districts({
    id: dto.id,
    name: dto.name,
    cod_district: dto.cod_district,
  });
}
/**
 * Townships
 */
export interface TownshipsDTO {
  id: number;
  name: string;
  cod_township: string;
}

export function TownshipsFromDTO(dto: TownshipsDTO): Townships {
  return new Townships({
    id: dto.id,
    name: dto.name,
    cod_township: dto.cod_township,
  });
}
